<template>
  <div class="promotion-page">
    <header class="promotion-page__header">
      <h1 class="promotion-page__title">{{ $t('footer.promotion') }}</h1>
      <p class="promotion-page__subtitle">{{ $t('promotion.subtitle') }}</p>
    </header>

    <div class="promotion-list">
      <article
        v-for="(promotion, proIndex) in promotions"
        :key="proIndex"
        class="promo-card"
      >
        <div class="promo-card__media">
          <img
            class="promo-card__img"
            :src="promotion.image"
            :alt="promotion.title"
            loading="lazy"
          >
          <span
            v-if="promotion.badge"
            class="promo-card__badge"
          >{{ promotion.badge }}</span>
        </div>
        <div class="promo-card__body">
          <h2 class="promo-card__title">{{ promotion.title }}</h2>
          <p class="promo-card__teaser">{{ promotion.teaser }}</p>
          <button
            type="button"
            class="promo-detail-btn"
            @click="promotionIndex(proIndex)"
          >
            <span class="promo-detail-btn__label">{{ $t('detail') }}</span>
            <span
              class="promo-detail-btn__chev"
              aria-hidden="true"
            >›</span>
          </button>
        </div>
      </article>
    </div>

    <van-overlay
      :show="selectedPromotion !== null"
      class-name="promo-overlay-root"
      @click="selectedPromotion = null"
    >
      <div
        class="promo-overlay-panel"
        @click.stop
      >
        <button
          type="button"
          class="promo-overlay-close"
          aria-label="Close"
          @click="selectedPromotion = null"
        >
          ×
        </button>
        <template v-if="activePromotion">
          <div class="promo-overlay-media">
            <img
              class="promo-overlay-img"
              :src="activePromotion.image"
              :alt="activePromotion.title"
            >
          </div>
          <div class="promo-overlay-copy">
            <h2 class="promo-overlay-title">{{ activePromotion.title }}</h2>
            <div
              class="promo-overlay-body"
              v-html="activePromotion.description"
            />
          </div>
        </template>
      </div>
    </van-overlay>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedPromotion: null,
      promotions: [
        {
          badge: 'NEW',
          title: 'မန်ဘာသစ်ဘောနပ်စ် 200%',
          teaser: 'CR7 ၏မန်ဘာသစ်တိုင်း (𝟏) ကြိမ် ရယူနိုင်ပါသည်။',
          description:
            `မန်ဘာသစ်ဘောနပ်စ် 200%<br /><br />
💠 ဤပရိုမိုးရှင်းသည် CR7 ၏မန်ဘာသစ်တိုင်း (𝟏) ကြိမ် ရယူနိုင်ပါသည်။<br /> <br />
💠 အနည်းဆုံးသွင်းငွေ ကျပ် 𝟑,𝟎𝟎𝟎 အထက်ရှိရပါမည်။<br /><br />
💠 အမြင့်ဆုံးရယူနိုင်သည့်ဘောနပ်စ်မှာ ငွေကျပ် 𝟑𝟎,𝟎𝟎𝟎 ဖြစ်ပါသည်။<br /><br />
💠 𝐒𝐋𝐎𝐓 မှလွဲ၍ အခြားဂိမ်းများအားလုံးကစားနိုင်ပါသည်။<br /><br />
💠 နိုင်ငွေ 𝟏𝟎 ဆ ပြည့်မှသာငွေထုတ်ယူနိုင်ပါမည်။ [( သွင်းငွေ+ဘောနပ်စ် ) x 𝟏𝟎 = နိုင်ငွေ ]<br /><br />
💠 အမြင့်ဆုံးထုတ်ယူနိုင်သည့် ပမာဏသည် သွင်းငွေ ၏ 𝟏𝟎 ဆ ဖြစ်ပြီး ကျန်ယူနစ်များအား 𝐬𝐞𝐫𝐯𝐞𝐫 မှ အော်တိုနုတ်ယူသွားမည်ဖြစ်ပါသည်။<br /><br />`,
          image: 'https://storage.googleapis.com/spacetech2/cr7/assets/promo1.avif',
        },
        {
          badge: 'DAILY',
          title: 'နေ့စဉ်ဘောနပ်စ် 30% (တစ်နေ့ 1 ကြိမ်)',
          teaser: 'CR7 ၏မန်ဘာဝင်တိုင်း နေ့စဉ် (𝟏) ကြိမ် ရယူနိုင်ပါသည်။',
          description:
            `နေ့စဉ်ဘောနပ်စ် 30% (တစ်နေ့ 1 ကြိမ်)<br /><br />
💠 ဤပရိုမိုးရှင်းသည် CR7 ၏မန်ဘာဝင်တိုင်း နေ့စဉ် (𝟏) ကြိမ် ရယူနိုင်ပါသည်။<br /><br />
💠 အနည်းဆုံးသွင်းငွေ ကျပ် 𝟑,𝟎𝟎𝟎 အထက်ရှိရပါမည်။<br /><br />
💠 အမြင့်ဆုံးရယူနိုင်သည့်ဘောနပ်စ်မှာ ငွေကျပ် 𝟐𝟓,𝟎𝟎𝟎 ဖြစ်ပါသည်။<br /><br />
💠 နိုင်ငွေ 𝟔 ဆပြည့်မှ သာငွေထုတ်ယူနိုင်ပါမည်။{(သွင်းငွေ+ဘောနပ်စ်)𝐱 𝟔 = နိုင်ငွေ }<br /><br />
💠 ကန့်သတ်ချက်မရှိ ငွေထုတ်ယူနိုင်ပါသည်။<br /><br />
💠 𝐒𝐋𝐎𝐓 တွက် 𝐟𝐫𝐞𝐞 𝐬𝐩𝐢𝐧 မဝယ်ရ ၊ စစ်ဆေးတွေ့ရှိပါက ငွေထုတ်ပေးမည်မဟုတ်ပါ။<br /><br />

⚠️ မှတ်ချက် ⚠️<br /><br />

• ဤပရိုမိုးရှင်းကို CR7 မှကြိုတင်အသိပေးခြင်းမရှိဘဲအချိန်မရွေးပြောင်းလဲနိုင်ပါသည်။<br /><br />

• ဆော့ကစားခွင့်မရသည့်ဂိမ်းများထဲသို ယူနစ်လွှပြောင်းထားခြင်းများနှင့် တခြား(တခြား)သောမသမာသောနည်းလမ်းပေါင်းများစွာဖြင့်လိမ်လည်ထားကြောင်းစစ်ဆေးတွေ့ရှိပါက CR7 𝐀𝐝𝐦𝐢𝐧 𝐓𝐞𝐚𝐦𝐬 အနေဖြင့် 𝐁𝐥𝐚𝐜𝐤 𝐋𝐢𝐬𝐭 စာရင်းသွင်းပါမည်။<br /><br />`,
          image: 'https://storage.googleapis.com/spacetech2/cr7/assets/promo2.avif',
        },
        {
          title: 'နေ့စဉ်ဘောနပ်စ် 20% (တစ်နေ့တစ်ကြိမ်)',
          teaser: 'အနည်းဆုံး 𝟑,𝟎𝟎𝟎 ကစသွင်းပါကဒီပရိုမိုးရှင်းရနိုင်ပါသည်။',
          description:
            `နေ့စဉ်ဘောနပ်စ် 20% (တစ်နေ့တစ်ကြိမ်)<br /><br />
💠 အနည်းဆုံး 𝟑,𝟎𝟎𝟎 ကစသွင်းပါကဒီပရိုမိုးရှင်းရနိုင်ပါသည်။<br /><br />

💠 အမြင့်ဆုံးရယူနိုင်သည့် 𝐁𝐨𝐧𝐮𝐬 မှာ ငွေကျပ် 𝟔𝟎,𝟎𝟎𝟎 ဖြစ်ပါသည်။<br /><br />

💠 ရှမ်းကိုးမီး နှင့် ဘူကြီး ကိုသာကစားနိုင်ပါသည်။<br /><br />

💠 နိုင်ငွေ 𝟑 ဆ ပြည့်မှသာ ငွေထုတ်ပေးပါမည်။<br /><br />

💠 ကန့်သတ်ချက်မရှိ ငွေပြန်လည်ထုတ်ယူနိုင်ပါသည်။<br /><br />

⚠️ မှတ်ချက် ⚠️<br /><br />

• ဤပရိုမိုးရှင်းကို CR7 မှကြိုတင်အသိပေးခြင်းမရှိဘဲအချိန်မရွေးပြောင်းလဲနိုင်ပါသည်။<br /><br />

• ဆော့ကစားခွင့်မရသည့်ဂိမ်းများထဲသို ယူနစ်လွှပြောင်းထားခြင်းများနှင့် တခြား(တခြား)သောမသမာသောနည်းလမ်းပေါင်းများစွာဖြင့်လိမ်လည်ထားကြောင်းစစ်ဆေးတွေ့ရှိပါက CR7 𝐀𝐝𝐦𝐢𝐧 𝐓𝐞𝐚𝐦𝐬 အနေဖြင့် 𝐁𝐥𝐚𝐜𝐤 𝐋𝐢𝐬𝐭 စာရင်းသွင်းပါမည်။<br /><br />`,
          image: 'https://storage.googleapis.com/spacetech2/cr7/assets/promo3.avif',
        },
        {
          title: 'SLOT သီးသန့်ပရိုမိုးရှင်း 20% (တစ်နေ့တစ်ကြိမ်)',
          teaser: 'CR7 ၏ မန်ဘာဝင်တိုင်းတစ်ရက် (𝟏) ကြိမ်ရယူနိုင်သည်။',
          description:
            `SLOT သီးသန့်ပရိုမိုးရှင်း 20% (တစ်နေ့တစ်ကြိမ်)<br /><br />
💠ဤပရိုမိုးရှင်းသည် CR7 ၏ မန်ဘာဝင်တိုင်းတစ်ရက် (𝟏) ကြိမ်ရယူနိုင်သည်။<br /><br />

💠 အနည်းဆုံးသွင်းငွေ ကျပ် 𝟑,𝟎𝟎𝟎 အထက်ရှိရမည်။<br /><br />

💠 အမြင့်ဆုံးရယူနိုင်သည့်ဘောနပ်စ်မှာ ကျပ် 𝟔𝟎,𝟎𝟎𝟎 ဖြစ်ပါသည်။<br /><br />

💠 စလော့များကိုသာ ကစားနိုင်ပါသည်။<br /><br />

💠 နိုင်ငွေ 𝟑 ဆ ပြည့်မှသာငွေထုတ်ယူနိုင်ပါမည်။ [( သွင်းငွေ+ဘောနပ်စ် ) x 3 = နိုင်ငွေ ]<br /><br />

💠 ကန့်သတ်ချက်မရှိ ငွေပြန်လည်ထုတ်ယူနိုင်ပါသည်။<br /><br />

⚠️ မှတ်ချက် ⚠️<br /><br />

• ဤပရိုမိုးရှင်းကို CR7 မှကြိုတင်အသိပေးခြင်းမရှိဘဲအချိန်မရွေးပြောင်းလဲနိုင်ပါသည်။<br /><br />

• ဆော့ကစားခွင့်မရသည့်ဂိမ်းများထဲသို ယူနစ်လွှပြောင်းထားခြင်းများနှင့် တခြား(တခြား)သောမသမာသောနည်းလမ်းပေါင်းများစွာဖြင့်လိမ်လည်ထားကြောင်းစစ်ဆေးတွေ့ရှိပါက CR7 𝐀𝐝𝐦𝐢𝐧 𝐓𝐞𝐚𝐦𝐬 အနေဖြင့် 𝐁𝐥𝐚𝐜𝐤 𝐋𝐢𝐬𝐭 စာရင်းသွင်းပါမည်။<br /><br />`,
          image: 'https://storage.googleapis.com/spacetech2/cr7/assets/promo4.avif',
        },
        {
          title: 'နေ့စဉ်ဘောနပ် 𝟏𝟎% (တစ်နေ့ 1 ကြိမ်)',
          teaser: 'CR7 ၏ မန်ဘာဝင်တိုင်းတစ်ရက် (𝟐) ကြိမ်ရယူနိုင်သည်။',
          description:
            `နေ့စဉ်ဘောနပ် 𝟏𝟎% (တစ်နေ့ 1 ကြိမ်)<br /><br />
💠 ဤပရိုမိုးရှင်းသည် CR7 ၏ မန်ဘာဝင်တိုင်းတစ်ရက် (𝟐) ကြိမ်ရယူနိုင်သည်။<br /><br />

💠 အနည်းဆုံးသွင်းငွေ ကျပ် 𝟓,𝟎𝟎𝟎 အထက်ရှိရမည်။<br /><br />

💠 အမြင့်ဆုံးရယူနိုင်သည့်ဘောနပ်စ်မှာ ကျပ် 𝟑𝟎,𝟎𝟎𝟎 ဖြစ်ပါသည်။<br /><br />

💠 နိုင်ငွေ 𝟐 ဆ ပြည့်မှသာငွေထုတ်နိုင်မည်။ [( သွင်းငွေ+ဘောနပ်စ် ) x2 = နိုင်ငွေ ]<br /><br />

💠 ကာစီနိုမှလွဲ၍ အခြားဂိမ်းများအားလုံးကစားနိုင်ပါသည်။<br /><br />

💠 𝐒𝐋𝐎𝐓 အတွက် 𝐅𝐫𝐞𝐞 𝐬𝐩𝐢𝐧 မဝယ်ရ ၊ စစ်ဆေးတွေ့ရှိပါကငွေထုတ်ပေးမည်မဟုတ်ပါ။<br /><br />

💠 ကန့်သတ်ချက်မရှိ ငွေထုတ်ယူနိုင်ပါသည်။<br /><br />

⚠️ မှတ်ချက် ⚠️<br /><br />

• ဤပရိုမိုးရှင်းကို CR7 မှကြိုတင်အသိပေးခြင်းမရှိဘဲအချိန်မရွေးပြောင်းလဲနိုင်ပါသည်။<br /><br />

• ဆော့ကစားခွင့်မရသည့်ဂိမ်းများထဲသို ယူနစ်လွှပြောင်းထားခြင်းများနှင့် တခြား(တခြား)သောမသမာသောနည်းလမ်းပေါင်းများစွာဖြင့်လိမ်လည်ထားကြောင်းစစ်ဆေးတွေ့ရှိပါက CR7 𝐀𝐝𝐦𝐢𝐧 𝐓𝐞𝐚𝐦𝐬 အနေဖြင့် 𝐁𝐥𝐚𝐜𝐤 𝐋𝐢𝐬𝐭 စာရင်းသွင်းပါမည်။<br /><br />`,
          image: 'https://storage.googleapis.com/spacetech2/cr7/assets/promo5.avif',
        },
        {
          title: 'သွင်းတိုင်းရ 5%',
          teaser: 'CR7 ၏ မန်ဘာဝင်တိုင်း ရယူနိုင်ပါသည်။',
          description:
            `သွင်းတိုင်းရ 5%<br /><br />
💠 ဤပရိုမိုးရှင်းသည် CR7 ၏ မန်ဘာဝင်တိုင်း ရယူနိုင်ပါသည်။<br /><br />

💠 အနည်းဆုံးသွင်းငွေ ကျပ် 𝟓,𝟎𝟎𝟎 အထက်ရှိရပါမည်။<br /><br />

💠 အမြင့်ဆုံးရယူနိုင်သည့်ဘောနပ်စ်မှာ ငွေကျပ် 𝟑𝟎,𝟎𝟎𝟎 ဖြစ်ပါသည်။<br /><br />

💠 ဂိမ်းများအားလုံး ကစားနိုင်ပါသည်။<br /><br />

💠 နိုင်ငွေ 𝟐 ဆ ပြည့်မှသာငွေထုတ်ယူနိုင်ပါမည်။ {(သွင်းငွေ+ဘောနပ်စ်)𝐱 𝟐 = နိုင်ငွေ }<br /><br />

💠 ကန့်သတ်ချက်မရှိ ငွေထုတ်ယူနိုင်ပါသည်။<br /><br />

⚠️ မှတ်ချက် ⚠️<br /><br />

• ဤပရိုမိုးရှင်းကို CR7 မှကြိုတင်အသိပေးခြင်းမရှိဘဲအချိန်မရွေးပြောင်းလဲနိုင်ပါသည်။<br /><br />

• ဤပရိုမိုးရှင်းအား တစ်စုံတစ်ရာ အငြင်းပွားဖွယ်ရှိပါက CR7 ၏ဆုံးဖြတ်ချက်သာ အတည်ဖြစ်သည်။<br /><br />`,
          image: 'https://storage.googleapis.com/spacetech2/cr7/assets/promo6.avif',
        },
        {
          title: 'နေ့စဉ်ရှူးကြေးပြန်အမ်းငွေဘောနပ်စ် 5%',
          teaser: ' CR7 ၏ မန်ဘာဝင်တိုင်း နေ့စဉ်ရှုးကြေး 𝟓% ကို (𝟏) ကြိမ်ရယူနိုင်သည်။',
          description:
            `နေ့စဉ်ရှူးကြေးပြန်အမ်းငွေဘောနပ်စ် 5%<br /><br />
💠 ဤပရိုမိုးရှင်းသည် CR7 ၏ မန်ဘာဝင်တိုင်း နေ့စဉ်ရှုးကြေး 𝟓% ကို (𝟏) ကြိမ်ရယူနိုင်သည်။<br /><br />

💠 တစ်ရက်အတွင်း ရှုးထားသောငွေ၏ 𝟓% ကိုပြန်ရယူနိုင်ပါသည်။<br /><br />

💠 ရှုးကြေးကို ည 𝟎𝟑:𝟎𝟎 နာရီနောက်ပိုင်းတွင် 𝐬𝐲𝐬𝐭𝐞𝐦 မှ 𝐚𝐮𝐭𝐨 ပြန်အမ်းပေးပါမည်။<br /><br />

💠 နိုင်ငွေ 𝟏 ဆ ပြည့်မှသာငွေထုတ်နိုင်မည်။<br /><br />

💠 ကန့်သတ်ချက်မရှိ ငွေထုတ်ယူနိုင်ပါသည်။<br /><br />

⚠️ မှတ်ချက် ⚠️<br /><br />

• ဤပရိုမိုးရှင်းကို CR7 မှကြိုတင်အသိပေးခြင်းမရှိဘဲအချိန်မရွေးပြောင်းလဲနိုင်ပါသည်။<br /><br />

• ဤပရိုမိုးရှင်းအား တစ်စုံတစ်ရာ အငြင်းပွားဖွယ်ရှိပါက CR7 ၏ဆုံးဖြတ်ချက်သာ အတည်ဖြစ်သည်။<br /><br />`,
          image: 'https://storage.googleapis.com/spacetech2/cr7/assets/promo7.avif',
        },

      ],
    };
  },
  computed: {
    activePromotion() {
      if (this.selectedPromotion === null) return null;
      return this.promotions[this.selectedPromotion] || null;
    },
  },
  methods: {
    promotionIndex(index) {
      this.selectedPromotion = index;
    },
  },
};
</script>

<style scoped>
.promotion-page {
  box-sizing: border-box;
  width: 100%;
  height: 100vh;
  max-height: 100dvh;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0.5rem 0.55rem calc(7.5rem + env(safe-area-inset-bottom, 0));
  background: linear-gradient(180deg, #11100e 0%, #0a0908 55%, #080706 100%);
}

.promotion-page__header {
  text-align: center;
  padding: 0.25rem 0.35rem 0.65rem;
}

.promotion-page__title {
  margin: 0;
  font-family: 'Cinzel', 'Times New Roman', serif;
  font-size: 1.15rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #d4b968;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.85);
}

.promotion-page__subtitle {
  margin: 0.45rem 0 0;
  font-size: 0.78rem;
  color: rgba(200, 192, 175, 0.75);
  line-height: 1.45;
}

.promotion-list {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  width: 100%;
  max-width: 28rem;
  margin: 0 auto;
  padding-bottom: 0.5rem;
}

.promo-card {
  width: 100%;
  margin: 0;
  border-radius: 12px;
  overflow: hidden;
  background: rgba(22, 19, 16, 0.95);
  border: none;
  box-shadow: 0 6px 22px rgba(0, 0, 0, 0.35);
}

.promo-card__media {
  position: relative;
  width: 100%;
  background: #050504;
  line-height: 0;
}

.promo-card__img {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 12px 12px 0 0;
}

.promo-card__badge {
  position: absolute;
  top: 0.45rem;
  left: 0.45rem;
  z-index: 1;
  padding: 0.2rem 0.45rem;
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  color: #1a1510;
  background: linear-gradient(135deg, #e8c547, #9a7218);
  border-radius: 6px;
}

.promo-card__body {
  padding: 0.75rem 0.9rem 1rem;
  background: linear-gradient(165deg, #161411 0%, #0e0d0b 55%, #0a0908 100%);
  border-top: 1px solid rgba(212, 175, 55, 0.12);
}

.promo-card__title {
  margin: 0 0 0.35rem;
  font-size: 0.93rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  line-height: 1.35;
  color: #f7f2ea;
}

.promo-card__teaser {
  margin: 0 0 0.65rem;
  font-size: 0.74rem;
  font-weight: 400;
  line-height: 1.55;
  color: #a9a094;
}

.promo-detail-btn {
  appearance: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.2rem;
  margin: 0;
  padding: 0.4rem 1rem 0.4rem 1.05rem;
  border-radius: 999px;
  border: 1px solid rgba(212, 175, 55, 0.5);
  background: linear-gradient(180deg,
      rgba(212, 175, 55, 0.12) 0%,
      rgba(18, 16, 12, 0.85) 100%);
  box-shadow:
    inset 0 1px 0 rgba(255, 235, 180, 0.12),
    0 2px 10px rgba(0, 0, 0, 0.35);
  color: #f0e4b8;
  font-family: inherit;
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  cursor: pointer;
  outline: none;
  transition:
    border-color 0.2s ease,
    background 0.2s ease,
    color 0.2s ease,
    transform 0.12s ease;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
  touch-action: manipulation;
}

.promo-detail-btn__label {
  line-height: 1.2;
}

.promo-detail-btn__chev {
  font-size: 1.05rem;
  font-weight: 300;
  line-height: 1;
  opacity: 0.9;
  transform: translateY(-0.04em);
}

.promo-detail-btn:hover {
  border-color: rgba(232, 210, 140, 0.75);
  background: linear-gradient(180deg,
      rgba(212, 175, 55, 0.2) 0%,
      rgba(26, 22, 16, 0.92) 100%);
  color: #fff8e4;
}

.promo-detail-btn:active {
  transform: scale(0.97);
}

.promo-detail-btn:focus-visible {
  outline: 2px solid rgba(212, 175, 55, 0.55);
  outline-offset: 2px;
}

.promo-overlay-panel {
  position: relative;
  width: calc(100% - 1.25rem);
  max-width: 26rem;
  max-height: min(86vh, 34rem);
  margin: 7vh auto 0;
  padding: 2.65rem 1rem 1.2rem;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  border-radius: 14px;
  background: linear-gradient(180deg, #1e1b18 0%, #12100e 100%);
  border: none;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.55);
}

.promo-overlay-media {
  width: 100%;
  margin: 0 0 0.85rem;
  border-radius: 10px;
  overflow: hidden;
  background: #050504;
  line-height: 0;
}

.promo-overlay-img {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 10px;
}

.promo-overlay-copy {
  padding: 0;
}

.promo-overlay-close {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  z-index: 2;
  width: 2.35rem;
  height: 2.35rem;
  border: 1px solid rgba(212, 175, 55, 0.35);
  border-radius: 50%;
  background: rgba(14, 12, 10, 0.92);
  color: #e8d49a;
  font-size: 1.25rem;
  line-height: 1;
  cursor: pointer;
  transition:
    border-color 0.2s ease,
    background 0.2s ease,
    color 0.2s ease;
}

.promo-overlay-close:hover {
  border-color: rgba(232, 210, 140, 0.55);
  color: #fff8e4;
  background: rgba(26, 22, 18, 0.95);
}

.promo-overlay-title {
  margin: 0 0 0.75rem;
  padding: 0 2.25rem 0.55rem 0;
  font-size: 1.02rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  line-height: 1.35;
  color: #f2ead8;
  border-bottom: 1px solid rgba(212, 175, 55, 0.22);
}

.promo-overlay-body {
  margin: 0;
  padding: 0.7rem 0.8rem 0.75rem 0.95rem;
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 1.68;
  letter-spacing: 0.01em;
  color: #c9c2b4;
  word-break: break-word;
  background: rgba(0, 0, 0, 0.28);
  border-radius: 10px;
  border-left: 3px solid rgba(212, 175, 55, 0.55);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
}

.promo-overlay-body ::v-deep p {
  margin: 0 0 0.55rem;
  color: inherit;
}

.promo-overlay-body ::v-deep p:last-child {
  margin-bottom: 0;
}

.promo-overlay-body ::v-deep em {
  color: #9a958a;
  font-style: italic;
}
</style>

<style>
/* Vant overlay: center panel without scoped pierce issues */
.promo-overlay-root {
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
</style>
